import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Automatic recovery for stale chunk loading errors when a new release deploys
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    const errorMsg = event?.message || (event?.error && event.error.message) || '';
    const isChunkFailure =
      typeof errorMsg === 'string' &&
      (errorMsg.includes('Loading chunk') ||
        errorMsg.includes('Failed to fetch dynamically imported module') ||
        errorMsg.includes('Importing a module script failed') ||
        errorMsg.includes('error loading dynamically imported module'));

    if (isChunkFailure) {
      const reloadKey = 'rapider_chunk_reload_ts';
      const lastReload = sessionStorage.getItem(reloadKey);
      const now = Date.now();
      // Allow reload once every 15 seconds to avoid infinite loops if genuine error
      if (!lastReload || now - parseInt(lastReload, 10) > 15000) {
        sessionStorage.setItem(reloadKey, now.toString());
        console.warn('New deployment bundle detected. Refreshing application...');
        window.location.reload();
      }
    }
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
